var $ = jQuery;
(function ($) {
  "use strict";
  $(document).ready(function () {
    $(".global-carousel").each(function () {
      var carouselSlide = $(this);

      // Collect Data
      function d(data) {
        return carouselSlide.data(data);
      }

      // Custom Arrow Button
      var prevButton =
          '<button type="button" class="slick-prev"><i class="' +
          d("prev-arrow") +
          '"></i></button>',
        nextButton =
          '<button type="button" class="slick-next"><i class="' +
          d("next-arrow") +
          '"></i></button>';

      // Function For Custom Arrow Btn
      $("[data-slick-next]").each(function () {
        $(this).on("click", function (e) {
          e.preventDefault();
          $($(this).data("slick-next")).slick("slickNext");
        });
      });

      $("[data-slick-prev]").each(function () {
        $(this).on("click", function (e) {
          e.preventDefault();
          $($(this).data("slick-prev")).slick("slickPrev");
        });
      });

      // Check for arrow wrapper
      if (d("arrows") == true) {
        if (!carouselSlide.closest(".arrow-wrap").length) {
          carouselSlide.closest(".container").parent().addClass("arrow-wrap");
        }
      }

      var slickOptions = {
        dots: d("dots") ? true : false,
        fade: d("fade") ? true : false,
        arrows: d("arrows") ? true : false,
        speed: d("speed") ? d("speed") : 1000,
        sliderNavfor: d("slidernavfor") ? d("slidernavfor") : false,
        autoplay: d("autoplay") == false ? false : true,
        infinite: d("infinite") == false ? false : true,
        slidesToShow: d("slide-show") ? d("slide-show") : 1,
        adaptiveHeight: d("adaptive-height") ? true : false,
        centerMode: d("center-mode") ? true : false,
        autoplaySpeed: d("autoplay-speed") ? d("autoplay-speed") : 8000,
        centerPadding: d("center-padding") ? d("center-padding") : "0",
        focusOnSelect: d("focuson-select") == false ? false : true,
        pauseOnFocus: d("pauseon-focus") ? true : false,
        pauseOnHover: d("pauseon-hover") ? true : false,
        variableWidth: d("variable-width") ? true : false,
        vertical: d("vertical") ? true : false,
        verticalSwiping: d("vertical") ? true : false,
        prevArrow: d("prev-arrow")
          ? prevButton
          : '<button type="button" class="slick-prev"><i class="fas fa-arrow-left"></i></button>',
        nextArrow: d("next-arrow")
          ? nextButton
          : '<button type="button" class="slick-next"><i class="fas fa-arrow-right"></i></button>',
        rtl: $("html").attr("dir") == "rtl" ? true : false,
        responsive: [
          {
            breakpoint: 1600,
            settings: d("xl-unslick") ? "unslick" : {
              arrows: d("xl-arrows") ? true : false,
              dots: d("xl-dots") ? true : false,
              slidesToShow: d("xl-slide-show")
                ? d("xl-slide-show")
                : d("slide-show"),
              centerMode: d("xl-center-mode") ? true : false,
              centerPadding: d("xl-center-padding")
                ? d("xl-center-padding")
                : "0",
            },
          },
          {
            breakpoint: 1400,
            settings: d("ml-unslick") ? "unslick" : {
              arrows: d("ml-arrows") ? true : false,
              dots: d("ml-dots") ? true : false,
              slidesToShow: d("ml-slide-show")
                ? d("ml-slide-show")
                : d("slide-show"),
              centerMode: d("ml-center-mode") ? true : false,
              centerPadding: d("ml-center-padding")
                ? d("ml-center-padding")
                : "0",
            },
          },
          {
            breakpoint: 1200,
            settings: d("lg-unslick") ? "unslick" : {
              arrows: d("lg-arrows") ? true : false,
              dots: d("lg-dots") ? true : false,
              slidesToShow: d("lg-slide-show")
                ? d("lg-slide-show")
                : d("slide-show"),
              centerMode: d("lg-center-mode") ? d("lg-center-mode") : false,
              centerPadding: d("lg-center-padding")
                ? d("lg-center-padding")
                : "0",
            },
          },
          {
            breakpoint: 992,
            settings: d("md-unslick") ? "unslick" : {
              arrows: d("md-arrows") ? true : false,
              dots: d("md-dots") ? true : false,
              slidesToShow: d("md-slide-show") ? d("md-slide-show") : 1,
              centerMode: d("md-center-mode") ? d("md-center-mode") : false,
              centerPadding: 0,
            },
          },
          {
            breakpoint: 768,
            settings: d("sm-unslick") ? "unslick" : {
              arrows: d("sm-arrows") ? true : false,
              dots: d("sm-dots") ? true : false,
              slidesToShow: d("sm-slide-show") ? d("sm-slide-show") : 1,
              centerMode: d("sm-center-mode") ? d("sm-center-mode") : false,
              centerPadding: 0,
            },
          },
          {
            breakpoint: 576,
            settings: d("xs-unslick") ? "unslick" : {
              arrows: d("xs-arrows") ? true : false,
              dots: d("xs-dots") ? true : false,
              slidesToShow: d("xs-slide-show") ? d("xs-slide-show") : 1,
              centerMode: d("xs-center-mode") ? d("xs-center-mode") : false,
              centerPadding: 0,
            },
          },
        ],
      };

      carouselSlide.slick(slickOptions);

      // Fix: Slick doesn't re-initialize after unslick on window resize.
      // When slick destroys itself at an unslick breakpoint, it won't come
      // back if the viewport grows again — so we re-init manually.
      var resizeTimer;
      $(window).on("resize", function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (!carouselSlide.hasClass("slick-initialized")) {
            carouselSlide.slick(slickOptions);
          }
        }, 200);
      });
    });
    $(".global-carousel").on(
      "afterChange",
      function (event, slick, currentSlide, nextSlide) {
        $(slick.$slides).find("[data-ani]").removeClass("slider-animated");
        $(slick.$slides[currentSlide])
          .find("[data-ani]")
          .addClass("slider-animated");
      },
    );

    $.fn.mobilemenu = function (options) {
      var opt = $.extend(
        {
          menuToggleBtn: ".menu-toggle",
          bodyToggleClass: "body-visible",
          subMenuClass: "submenu-class",
          subMenuParent: "submenu-item-has-children",
          subMenuParentToggle: "active-class",
          meanExpandClass: "mean-expand-class",
          appendElement: '<span class="mean-expand-class"></span>',
          subMenuToggleClass: "menu-open",
          toggleSpeed: 400,
        },
        options,
      );

      return this.each(function () {
        var menu = $(this); // Select menu

        // Menu Show & Hide
        function menuToggle() {
          menu.toggleClass(opt.bodyToggleClass);

          // collapse submenu on menu hide or show
          var subMenu = "." + opt.subMenuClass;
          $(subMenu).each(function () {
            if ($(this).hasClass(opt.subMenuToggleClass)) {
              $(this).removeClass(opt.subMenuToggleClass);
              $(this).css("display", "none");
              $(this).parent().removeClass(opt.subMenuParentToggle);
            }
          });
        }

        // Class Set Up for every submenu
        menu.find("li").each(function () {
          var submenu = $(this).find("ul");
          submenu.addClass(opt.subMenuClass);
          submenu.css("display", "none");
          submenu.parent().addClass(opt.subMenuParent);
          submenu.prev("a").append(opt.appendElement);
          submenu.next("a").append(opt.appendElement);
        });

        // Toggle Submenu
        function toggleDropDown($element) {
          if ($($element).next("ul").length > 0) {
            $($element).parent().toggleClass(opt.subMenuParentToggle);
            $($element).next("ul").slideToggle(opt.toggleSpeed);
            $($element).next("ul").toggleClass(opt.subMenuToggleClass);
          } else if ($($element).prev("ul").length > 0) {
            $($element).parent().toggleClass(opt.subMenuParentToggle);
            $($element).prev("ul").slideToggle(opt.toggleSpeed);
            $($element).prev("ul").toggleClass(opt.subMenuToggleClass);
          }
        }

        // Submenu toggle Button
        var expandToggler = "." + opt.meanExpandClass;
        $(expandToggler).each(function () {
          $(this).on("click", function (e) {
            e.preventDefault();
            toggleDropDown($(this).parent());
          });
        });

        // Menu Show & Hide On Toggle Btn click
        $(opt.menuToggleBtn).each(function () {
          $(this).on("click", function () {
            menuToggle();
          });
        });

        // Hide Menu On out side click
        menu.on("click", function (e) {
          e.stopPropagation();
          menuToggle();
        });

        // Stop Hide full menu on menu click
        menu.find("div").on("click", function (e) {
          e.stopPropagation();
        });
      });
    };

    $(".mobile-menu-wrapper").mobilemenu();

    // Close mobile menu when an anchor link is clicked.
    // Must bind directly (not delegated) because the plugin's stopPropagation
    // on inner divs prevents bubbling up to the wrapper.
    $(".mobile-menu-wrapper a").each(function () {
      var href = $(this).attr("href") || "";
      var hash = href.indexOf("#") !== -1 ? href.replace(/.*#/, "") : "";
      if (hash.length > 0) {
        $(this).on("click", function () {
          $(".mobile-menu-wrapper").removeClass("body-visible");
        });
      }
    });

    $(window).scroll(function () {
      var topPos = $(this).scrollTop();
      if (topPos > 500) {
        $('.sticky-wrapper').addClass('sticky');
      } else {
        $('.sticky-wrapper').removeClass('sticky')
      }
    });

    $(".popup-video").magnificPopup({
      type: "iframe",
      mainClass: 'mfp-zoom-in', 
      removalDelay: 260,
    });

  });
})(jQuery);
